import React, { useEffect, useState } from 'react'
import TreechatIcon from 'components/shared/icons/TreechatIcon'
import Login from './Login'
import Signup from './Signup'
import styles from './auth.module.scss'

export default function AuthModal({ modalParams, closeModal }) {
    const initialMode = modalParams?.mode === 'login' ? 'login' : 'signup'
    const authSource = modalParams?.authSource || 'unknown'
    const [mode, setMode] = useState(initialMode)

    useEffect(() => {
        setMode(initialMode)
    }, [initialMode])

    return (
        <div className={styles.modalShell}>
            <div className={styles.modalBody}>
                <div className={styles.modalBrand}>
                    <img
                        src="/treechat-logo-text.png"
                        alt="Treechat"
                        className={styles.modalLogoImg}
                    />
                </div>

                <div className={styles.authPanel}>
                    {mode === 'login' ? (
                        <Login
                            embedded
                            analyticsSource={authSource}
                            onSwitchMode={() => setMode('signup')}
                            onAuthenticated={closeModal}
                        />
                    ) : (
                        <Signup
                            embedded
                            analyticsSource={authSource}
                            onSwitchMode={() => setMode('login')}
                            onAuthenticated={closeModal}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}
